import { CSSObject } from '@mui/material';

import transitions from '../options/transitions';

const textfield: CSSObject = {
  styleOverrides: {
    root: {
      'position': 'relative',

      'display': 'flex',

      'transition': `${transitions.duration?.short}ms ${transitions.easing?.easeOut}`,

      '*, *::before, &::after': {
        transition: `${transitions.duration?.short}ms ${transitions.easing?.easeOut}`
      }
    }
  }
};

export default textfield;
